export class WebResult {
  constructor(
      public messageToken: string,
      public isSuccess: boolean,
      public data?: any
  ) {}
}

export class WebResultGeneric<T> {
  constructor(
      public messageToken: string,
      public isSuccess: boolean,
      public data?: T
  ) {}
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/shared-module/models/web-result.ts